/**
 * @fileoverview O seletor "Números de" das telas de indicadores, com o estado
 * do useDepartmentScope: a visão de sempre da tela (baseLabel), todos os
 * departamentos da pessoa (com mais de um) ou um deles. Sem departamentos, não
 * aparece.
 */

import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import ModernSelect from "../ModernSelect";
import { BASE_SCOPE } from "../../hooks/useDepartmentScope";
import { i18n } from "../../translate/i18n";

const DepartmentScopeSelect = ({ departmentScope, baseLabel, className, labelClassName, selectClassName }) => {
  const { departments, scope, setScope, canSeeBase } = departmentScope;
  if (!departments.length || scope === null) return null;
  const label = i18n.t("dashboard.scope.label");
  return (
    <div className={className}>
      <span className={labelClassName}>{label}</span>
      <ModernSelect
        value={scope}
        onChange={(e) => setScope(e.target.value)}
        className={selectClassName}
        formControlProps={{ size: "small" }}
        inputProps={{ "aria-label": label }}
      >
        {canSeeBase && <MenuItem value={BASE_SCOPE}>{baseLabel}</MenuItem>}
        {departments.length > 1 && <MenuItem value="all">{i18n.t("dashboard.scope.allMine")}</MenuItem>}
        {departments.map((department) => (
          <MenuItem key={department.id} value={String(department.id)}>{department.name}</MenuItem>
        ))}
      </ModernSelect>
    </div>
  );
};

export default DepartmentScopeSelect;
